import {FC} from "react";

const TableData: FC = ({children}) => {
  return <div className='table--td'>
    {children}
  </div>;
}

export default TableData;
